import { render, staticRenderFns } from "./TopMenosClientesCard.vue?vue&type=template&id=5f62e764"
import script from "./TopMenosClientesCard.vue?vue&type=script&lang=js"
export * from "./TopMenosClientesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports